module.exports = __webpack_public_path__ + "static/media/DSC_0243.ed74fa9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0243.jpg
// module id = 652
// module chunks = 0